export function cleanFoodName(raw: string): string {
  if (!raw) return '';
  let s = ' ' + raw.toLowerCase().replace(/\s+/g, ' ').trim() + ' ';
  // rumore commerciale
  s = s.replace(/\b(omaggio|omag\.?|regalo|gratis|free|sconto|sconti|promo|promozione|cad\.?|caduno|caduna)\b/gi, ' ');
  // confezione: numeri+UoM con virgola/punto, es "2,5 kg", "0.5 l", "500 g"
  s = s.replace(/(?<![\d/])\b\d+(?:[.,]\d+)?\s?(?:kg|g|gr|grammi|l|lt|litri|ml|cl|pz|pezzi|cf|conf|conf\.|confezione|x)\b/gi, ' ');
  // pattern "ml 250", "g 500", "kg 2,5"
  s = s.replace(/\b(?:kg|g|gr|grammi|l|lt|ml|cl|pz)\s?\d+(?:[.,]\d+)?\b/gi, ' ');
  // pattern "12x180g" o "6 x 1l"
  s = s.replace(/\b\d+\s?[x×]\s?\d+(?:[.,]\d+)?\s?(?:kg|g|gr|l|lt|ml|cl|pz)?\b/gi, ' ');
  // codici "art." "cod." con numeri
  s = s.replace(/\b(?:art|cod|ref)\.?\s?\w+\b/gi, ' ');
  // Preserve standalone grades/counts: 'French Fries 10 mm', 'n. 3', etc.
  // Parentesi vuote o con solo whitespace/punteggiatura residuo dopo lo strip
  // del peso ("Petto di Pollo (kg 18)" → "Petto di Pollo ( )" → "Petto di Pollo")
  s = s.replace(/\(\s*[\s.,;:\-/]*\s*\)/g, ' ');
  s = s.replace(/\[\s*[\s.,;:\-/]*\s*\]/g, ' ');
  // collapse spazi, strip
  return s.replace(/\s+/g, ' ').trim();
}

